// extracted by mini-css-extract-plugin
module.exports = {"container":"countdown_container__tdG_U"};